/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const save = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.133 5.2 8 7.067m0 0L9.867 5.2M8 7.067V1m.5 11.5H4m8.044 0h-.622M1.933 15h12.134a.933.933 0 0 0 .933-.933v-3.734a.933.933 0 0 0-.933-.933H1.933a.933.933 0 0 0-.933.933v3.734c0 .515.418.933.933.933Z"
    />
  </svg>
)
export default save
